import { render, staticRenderFns } from "./Motivoscrud.vue?vue&type=template&id=5b00d2e0"
import script from "./Motivoscrud.vue?vue&type=script&lang=js"
export * from "./Motivoscrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports